<template>
    <div class="grafico-container" @fullscreenchange="teste">
        <ScaleLoader class="grafico" v-if="loading" :loading="loading"></ScaleLoader>
        <div v-else class="grafico">
            <div class="header">
                <div class="row">
                    <div class="sm-7">
                        <div class="title">RESUMO DESPESAS</div>
                    </div>
                    <div class="sm-5 text-right">
                        <button @click="fullscreen" class="default-button">
                            <font-awesome-icon fixed-width :icon="faExpandAlt"></font-awesome-icon>
                        </button>
                        <button @click="showModal = true" class="default-button">
                            <font-awesome-icon fixed-width :icon="faCalendarAlt"></font-awesome-icon>
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="sm-12 md-6">
                        <select v-model="SubConta">
                            <option
                                v-for="subconta in SubContas"
                                :key="subconta"
                                :value="subconta"
                            >{{ subconta }}</option>
                        </select>
                    </div>
                    <div class="sm-12 md-6">
                        <select v-model="fechamento_referencia">
                            <option
                                :value="fechamento.referencia"
                                v-for="fechamento in fechamentos"
                                :key="fechamento.referencia"
                            >{{ fechamento.referencia }}</option>
                        </select>
                    </div>
                </div>

                <div class="row flex justify-end">
                    <div
                        class="sm-12 text-right padding text-grey"
                    >Total: {{ total | number_format }}</div>
                </div>
            </div>
            <div class="row">
                <div class="sm-12">
                    <label>
                        <input
                            type="checkbox"
                            v-model="mostrar_legendas"
                            style="visibility: hidden;"
                        />
                        <i class="mdi mdi-checkbox-marked mdi-18px" v-if="mostrar_legendas"></i>
                        <i class="mdi mdi-checkbox-blank-outline mdi-18px" v-else></i>
                        Mostrar Legendas
                    </label>
                </div>
            </div>
            <Chart :config="config"></Chart>
            <Modal v-if="showModal" @close="showModal = false" @confirmed="updateDatas">
                <div class="row">
                    <div class="sm-12 md-6">
                        <input type="date" lang="pt" v-model="inicio" placeholder="Data Início" />
                    </div>
                    <div class="sm-12 md-6">
                        <input type="date" lang="pt" v-model="fim" placeholder="Data Término" />
                    </div>
                </div>
            </Modal>
        </div>
    </div>
</template>
<script>
import api from "/plugins/api";
import chroma from "chroma-js";

import ScaleLoader from "vue-spinner/src/ScaleLoader";
import Chart from "./Chart.vue";
import Modal from "~/components/Modal.vue";

//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faExpandAlt } from "@fortawesome/free-solid-svg-icons/faExpandAlt";

const number_format = value => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(+value);
}; 

export default {
    props: ["codigo_condominio", "codigo_cliente", "data_inicio", "data_fim"],
    components: {
        ScaleLoader,
        FontAwesomeIcon: () => import("@fortawesome/vue-fontawesome").then(e => e.FontAwesomeIcon),
        Chart,
        Modal
    },
    filters: {
        number_format
    },
    data() {
        return {
            loading: false,
            error: null,
            mostrar_legendas: true,
            subconta: "",
            faCalendarAlt,
            faExpandAlt,
            chart: null,
            dataInicio: null,
            dataFim: null,
            Inicio: null,
            Fim: null,
            showModal: false,
            fechamento_referencia: null,
            fechamentos: []
        };
    },
    computed: {
        inicio: {
            get() {
                if (!this.Inicio) {
                    return null;
                }
                return this.Inicio.split("/")
                    .reverse()
                    .join("-");
            },
            set(value) {
                let [data, hora] = value.split("T");
                this.Inicio = data
                    .split("-")
                    .reverse()
                    .join("/");
            }
        },
        fim: {
            get() {
                if (!this.Fim) {
                    return null;
                }
                return this.Fim.split("/")
                    .reverse()
                    .join("-");
            },
            set(value) {
                let [data, hora] = value.split("T");
                this.Fim = data
                    .split("-")
                    .reverse()
                    .join("/");
            }
        },
        SubConta: {
            get() {
                if (this.subconta == "" && this.SubContas.length != 0) {
                    let [subconta] = this.SubContas;
                    return subconta;
                }
                return this.subconta;
            },
            set(value) {
                this.subconta = value;
            }
        },
        SubContas() {
            let subcontas = this.rows.map(({ subconta }) => subconta);
            return [...new Set(subcontas)];
        },
        Referencias() {
            let referencias = this.fechamentos.map(
                ({ referencia }) => referencia
            );
            return [...new Set(referencias)];
        },
        empresa() {
            return this.$store.state.empresa;
        },
        colors() {
            return this.empresa.colors;
        },
        cores() {
            return this.colors.multiple;            
        },
        config() {
            let rows = this.rows.filter(
                ({ subconta }) => subconta == this.SubConta
            );
            let labels = rows.map(({ descricao, valor }) => `${descricao} - ${number_format(valor)}`);
            let data = rows.map(({ valor }) => valor);

            const getRandomColor = () => {
                var letters = "0123456789ABCDEF";
                var color = "#";
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            };

            let backgroundColor = data.map(() => getRandomColor());
            backgroundColor = chroma
                .scale(this.cores)
                .colors(data.length);

            let config = {
                type: "pie",

                data: {
                    labels,
                    datasets: [
                        {
                            data,
                            backgroundColor
                        }
                    ]
                },
                options: {
                    legend: {
                        position: "bottom",
                        display: this.mostrar_legendas
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipitem, data) => {
                                let { index } = tooltipitem;
                                let label = data.labels[index];
                                let value = data.datasets[0].data[index];
                                let valor = number_format(value);
                                valor = ''
                                return `${label} ${valor}`;
                            }
                        }
                    }
                }
            };

            return config;
        },
        fechamento() {
            if (this.fechamento_referencia != null) {
                let fechamento = this.fechamentos.find(
                    fechamento =>
                        fechamento.referencia == this.fechamento_referencia
                );
                return fechamento;
            }
            return null;
        },
        rows() {
            if (!this.fechamento) {
                return [];
            }
            return this.fechamento.despesas;
        },
        total() {
            if (!this.fechamento) {
                return "";
            }
            return this.fechamento.total;
        }
    },
    methods: {
        teste(e) {
            if (document.fullscreenElement) {
            } else {
                this.loading = true;
                this.$nextTick(() => {
                    this.loading = false;
                });
            }
        },
        fullscreen() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                this.$el.requestFullscreen();
            }
        },
        updateDatas() {
            this.dataInicio = this.Inicio;
            this.dataFim = this.Fim;
            this.showModal = false;
        },
        async loadData() {
            this.loading = true;

            if (!this.inicio || !this.fim) {
                return;
            }

            try {
                let { data: fechamentos } = await api.get(
                    `condominios/${this.codigo_condominio}/indicadores/${this.inicio}/${this.fim}/despesa`
                );

                fechamentos = fechamentos.map(
                    ({ Referencia: referencia, Total: total, Despesas }) => {
                        let despesas = Despesas.map(
                            ({
                                SubConta: subconta,
                                Descricao: descricao,
                                Valor: valor
                            }) => ({ referencia, subconta, descricao, valor })
                        );
                        return {
                            referencia,
                            total,
                            despesas
                        };
                    }
                );

                /*
                let fechamentos = await resumoDespesa({
                    CodCondominio: this.codigo_condominio,
                    CodCliente: this.codigo_cliente,
                    DataIni: this.dataInicio,
                    DataFim: this.dataFim
                });
                */

                if (fechamentos.length != 0) {
                    let f = [...fechamentos];
                    f.reverse();
                    let [fechamento] = f;
                    this.fechamento_referencia = fechamento.referencia;
                }
                this.fechamentos = fechamentos;

                //this.rows = records;
            } catch (err) {
                this.error = err.message;
                console.error("erro ", err);
            }

            this.loading = false;
        }
    },
    watch: {
        dataInicio() {
            this.Inicio = this.dataInicio;
            this.loadData();
        },
        dataFim() {
            this.Fim = this.dataFim;
            this.loadData();
        },
        data_inicio: {
            immediate: true,
            handler(value) {
                this.dataInicio = value;
            }
        },
        data_fim: {
            immediate: true,
            handler(value) {
                this.dataFim = value;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.grafico-container {
    
    width: 100%;
    margin-bottom: 1em;
    
}
.grafico {
    //padding: 1em;
    height: 100%;
    background-color: white;
    border: 1px solid lightgrey;
    border-radius: 0.5em;
    //margin: 0.5em;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    position: relative;
    &:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }

    .chart-container {
        min-height: 400px;
    }

    .header {
        padding-top: 1em;
    }
    .buttons {
        select {
            width: auto;
        }
        button {
            margin-left: 1em;
        }
    }
    .default-button {
        padding: 13px 13px;
    }
    .title {
        background-color: white;
        color: black;
    }
    .row {
        margin: auto !important;
    }
}
</style>
<style lang="less">
.vdatetime {
    margin: 0.5em;
    input.vdatetime-input {
        border: 1px solid #ddd;
        padding: 1em;
    }
}
</style>